import React, { useEffect, useState } from 'react';

import {
  BookLinkValidationError,
  normalizeBookLink,
} from './bookLink';


const LinkPanel = ({
  open,
  initialText = '',
  initialHref = '',
  editing = false,
  onConfirm,
  onRemove,
  onCancel,
}) => {
  const [text, setText] = useState(initialText);
  const [href, setHref] = useState(initialHref);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!open) return;
    setText(initialText);
    setHref(initialHref);
    setError('');
  }, [open, initialText, initialHref]);

  if (!open) return null;

  const submit = (event) => {
    event.preventDefault();
    const visibleText = text.trim();
    if (!visibleText) {
      setError('Saisissez le texte à afficher.');
      return;
    }
    try {
      onConfirm?.({ text: visibleText, ...normalizeBookLink(href) });
    } catch (exception) {
      setError(
        exception instanceof BookLinkValidationError
          ? exception.message
          : 'Impossible de créer ce lien.'
      );
    }
  };

  return (
    <form
      className="mb-3 grid gap-3 rounded-lg border border-blue-200 bg-blue-50 p-4"
      aria-label="Éditeur de lien"
      onSubmit={submit}
    >
      <p className="text-sm font-semibold text-blue-900">
        {editing ? 'Modifier le lien sélectionné' : 'Ajouter un lien au texte'}
      </p>
      <label className="grid gap-1 text-sm">
        <span>Texte à afficher</span>
        <input
          aria-label="Texte à afficher"
          className="rounded border border-gray-300 bg-white px-2 py-1"
          value={text}
          onChange={(event) => {
            setText(event.target.value);
            setError('');
          }}
        />
      </label>
      <label className="grid gap-1 text-sm">
        <span>Adresse du lien</span>
        <input
          aria-label="Adresse du lien"
          className="rounded border border-gray-300 bg-white px-2 py-1"
          value={href}
          placeholder="https://exemple.com"
          onChange={(event) => {
            setHref(event.target.value);
            setError('');
          }}
        />
      </label>
      {error && (
        <p role="alert" className="text-sm text-red-700">
          {error}
        </p>
      )}
      <div className="flex flex-wrap justify-end gap-2">
        {editing && onRemove && (
          <button type="button" className="text-red-700" onClick={onRemove}>
            Supprimer le lien
          </button>
        )}
        <button type="button" onClick={onCancel}>
          Annuler
        </button>
        <button type="submit">
          {editing ? 'Mettre à jour le lien' : 'Ajouter le lien'}
        </button>
      </div>
    </form>
  );
};

export default LinkPanel;
